// @generated by TypeGen from LogbookModel/StoredCalculation.swift - DO NOT EDIT

import type { ICruiseCalculations } from "./Cruise"
import type { IDayCalculations } from "./Day"
import type { ILogCalculations } from "./Log"
import type { ILogbookModel } from "./Model"
import type { IShipCalculations } from "./Ship"
import type { ITripCalculations } from "./Trip"

export interface IStoredCalculation extends ILogbookModel {
  id: number;
  accountId: number;
  shipId: number;
  createdAt: string;
  updatedAt: string;
  syncedAt?: string;
  data: string;
  sourceId: number;
  sourceType: IStoredCalculationSource;
  version: number;
}

export interface IStatusCalculations {
}

export interface ITestCalculations {
}

export interface ICalculationResult<T> {
  id: number;
  values: T;
  version: number;
}

export interface IStoredCalculationTimeseries<T> {
  resolution: number;
  data: T[];
}

export enum IStoredCalculationSource {
  day = 1,
  trip = 2,
  cruise = 3,
  log = 4,
  status = 5,
  ship = 6,
  test = 100,
}

export interface IStoredCalculationDataMap {
  [IStoredCalculationSource.day]: IDayCalculations;
  [IStoredCalculationSource.trip]: ITripCalculations;
  [IStoredCalculationSource.cruise]: ICruiseCalculations;
  [IStoredCalculationSource.log]: ILogCalculations;
  [IStoredCalculationSource.status]: IStatusCalculations;
  [IStoredCalculationSource.ship]: IShipCalculations;
  [IStoredCalculationSource.test]: ITestCalculations;
}

export type IStoredCalculationParsed = { [K in IStoredCalculationSource]: Omit<IStoredCalculation, "data"> & { sourceType: K; dataParsed: IStoredCalculationDataMap[K] } }[IStoredCalculationSource];

export const StoredCalculation = {
  parse(r: IStoredCalculation): IStoredCalculationParsed {
    return { ...r, dataParsed: r.data != null ? JSON.parse(r.data) : {} } as IStoredCalculationParsed;
  },
};
